export default {
  dashboardConfig: {},
  defaultDashboard: '',
  selectedDashboard: null,
  dashboards: [],
  dashboardItems: {},
  dashboardLoading: { dashboardDetail: false, dashboardOverview: false },
};
